import { io } from "socket.io-client";
import Emitter from 'component-emitter';
import { GET_TOKEN, REFRESH_TOKEN } from "@/store/constants";
import store from "@/store";
export const UNIVERSALAI_SOCKET = {
  socket: null,
  connected: false,
  connecting: false,
  init(){
    try { 
      Emitter(this)
      window.UNIVERSALAI_SOCKET = this
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return this
    }
  },
  async onInvalidToken(message){
    if (["Token Expired","Invalid Token"].includes(message)) {
      await store.dispatch(REFRESH_TOKEN)
      this.socket.auth.token = store.getters[GET_TOKEN];
      this.socket.connect();
    }
  },
  connect(){
    if(this.connecting) return;
    try {
      this.connecting=true
      if(this.connected) throw new Error('Already Connected')
      this.socket = io(`${new URL(process.env.VUE_APP_UNIVERSAL_AI_URL).origin}/admin`,{
        autoConnect: false,
        closeOnBeforeunload: true,
        reconnection: true,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: 5,
        auth: {
          token: store.getters[GET_TOKEN]
        },
      });
      this.socket.on('connect',this.onConnect.bind(this))
      this.socket.on('disconnect',this.onDisconnect.bind(this))
      this.socket.on("connect_error", this.onConnectError.bind(this));
      this.socket.onAny(this.onAnyEvent.bind(this));
      this.socket.connect()
    } catch (ex) {
      console.log('UNIVERSALAI SOCKET connect error',ex)
      throw ex
    } finally {
      this.connecting=false
    }
  },
  disconnect(){
    this.socket?.disconnect?.()
  },
  onConnect(){
    console.log('UNIVERSALAI SOCKET connected')
    this.connected=true
  },
  async onConnectError(err){
    try {
      console.log('UNIVERSALAI SOCKET connect error',err,this.socket?.active)
      if(!this.socket?.active) {
        await this.onInvalidToken(err.message)
      }
    } catch (ex) {
      console.log('UNIVERSALAI SOCKET connect error exception',ex)
    }
  },
  onDisconnect(reason){
    console.log('UNIVERSALAI SOCKET disconnect',reason,this.socket?.active)
    this.connected=false
    if (!this.socket?.active) {
      if (reason=='io client disconnect') {
        this.socket=null
      }
    }
  },
  async onAnyEvent(event,...args){
    try {
      if(event=='error') {
        const [payload] = args
        await this.onInvalidToken(payload.message)
      } else {
        this.emit(event,...args)
      }
    } catch (ex) {
      console.log('UNIVERSALAI SOCKET any event exception',ex)
    }
  },
}